import { findDisplayCreatives } from "./providers/displayCreativeWatcher";

/** Attributes whose mutation can change readDisplayAdSize(). */
export var DISPLAY_AD_SIZE_ATTRIBUTES = [
  "data-ad-width",
  "data-ad-height",
  "width",
  "height",
];

function pixelSize(value) {
  if (value == null) return 0;
  var text = String(value).trim();
  if (!/^\d+(\.\d+)?(px)?$/.test(text)) return 0;
  return parseFloat(text);
}

function creativeSize(creative) {
  return {
    width:
      pixelSize(creative.getAttribute("width")) ||
      pixelSize(creative.style && creative.style.width) ||
      (creative.tagName === "IMG" ? creative.naturalWidth : 0),
    height:
      pixelSize(creative.getAttribute("height")) ||
      pixelSize(creative.style && creative.style.height) ||
      (creative.tagName === "IMG" ? creative.naturalHeight : 0),
  };
}

function isRendered(el) {
  return typeof el.getClientRects !== "function" || el.getClientRects().length > 0;
}

/**
 * Native size of what a .display-ad is showing. Providers can serve a creative
 * whose size differs from the bid unit, so the creative's own declared size
 * (attribute, inline px style, or loaded image size) wins; the selected unit
 * (data-ad-width / data-ad-height) is used until a creative is in the slot.
 * When the served markup holds several sized elements (e.g. a text ad's
 * thumbnail beside its frame) the largest rendered one is the creative, so a
 * nested or display:none element never shrinks the slot around it.
 * Never reads rendered geometry, which callers scale.
 *
 * @param {HTMLElement} unit .display-ad element
 * @returns {{width: number, height: number, source: string}|null}
 */
export function readDisplayAdSize(unit) {
  if (!unit || typeof unit.getAttribute !== "function") return null;
  var best = null;
  findDisplayCreatives(unit).forEach(function (creative) {
    if (!isRendered(creative)) return;
    var size = creativeSize(creative);
    if (!(size.width > 1 && size.height > 1)) return;
    if (!best || size.width * size.height > best.width * best.height) best = size;
  });
  if (best) {
    return { width: best.width, height: best.height, source: "creative" };
  }
  var unitWidth = Number(unit.getAttribute("data-ad-width"));
  var unitHeight = Number(unit.getAttribute("data-ad-height"));
  if (unitWidth > 0 && unitHeight > 0) {
    return { width: unitWidth, height: unitHeight, source: "unit" };
  }
  return null;
}
